import { Button } from "@/components/ui/button";
import { Save, Loader2 } from "lucide-react";
import { DealEditorProps } from "./types";

interface DealHeaderProps extends Pick<DealEditorProps, "mode" | "onCancel"> {
  loading: boolean;
  onSave: () => void;
}

export function DealHeader({
  mode,
  loading,
  onSave,
  onCancel,
}: DealHeaderProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">
            {mode === "create"
              ? "Create New Deal Template"
              : "Edit Deal Template"}
          </h1>
          <p className="text-muted-foreground mt-2">
            {mode === "create"
              ? "Add a new hotel deal template with complete underwriting data"
              : "Update deal template with full underwriting data"}
          </p>
        </div>

        <div className="flex items-center gap-2">
          <Button variant="outline" onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={onSave}
            disabled={loading}
            className="gap-2 bg-primary-blue"
          >
            {loading ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Save className="h-4 w-4" />
            )}
            {mode === "create" ? "Create Template" : "Save Changes"}
          </Button>
        </div>
      </div>
    </div>
  );
}
